/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CustomerDto } from '../../models/customer-dto';

export interface ApiCustomerGet$Json$Params {
}

export function apiCustomerGet$Json(http: HttpClient, rootUrl: string, params?: ApiCustomerGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CustomerDto>>> {
  const rb = new RequestBuilder(rootUrl, apiCustomerGet$Json.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<CustomerDto>>;
    })
  );
}

apiCustomerGet$Json.PATH = '/api/Customer';
